export default function BankIllustration({ style }) {
  return (
    <svg
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={style}
      aria-hidden="true">
      {/* Roof */}
      <path d="M32 6 L58 22 L6 22 Z" fill="currentColor" />
      {/* Columns */}
      <rect x="12" y="26" width="5" height="22" fill="currentColor" />
      <rect x="21" y="26" width="5" height="22" fill="currentColor" />
      <rect x="30" y="26" width="5" height="22" fill="currentColor" />
      <rect x="39" y="26" width="5" height="22" fill="currentColor" />
      <rect x="48" y="26" width="5" height="22" fill="currentColor" />
      {/* Base */}
      <rect x="6" y="52" width="52" height="6" rx="1" fill="currentColor" />
    </svg>
  );
}
